// @ts-nocheck
/* eslint-disable react/prop-types */
import React, { useMemo, useEffect,createContext,useContext } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import { visuallyHidden } from '@mui/utils';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Link, useLocation  } from 'react-router-dom';
//import Ts from "./TS.tsx";
import {useIntl  , FormattedMessage } from 'react-intl';
import ReactGA from "react-ga4";
import Refresh from './components/refresh';
import {LoginContext,LoadingContext} from '../Default';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from 'material-react-table';
import {  colors } from '@mui/material';
//import { data, type Person } from './makeData';
import {type C2List}  from "./data/tdb_c2";
import './TS.css';
import Chip from '@mui/material/Chip';
import { MRT_Localization_JA } from 'material-react-table/locales/ja';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
//import {RefreshContext} from './SearchResult';
// Google Analytics 測定 ID を入力して設定
ReactGA.initialize(process.env.REACT_APP_GA_KEY);
// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
// }));
//export const RefreshContext = createContext();
const handleReady = () => {

};
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));
const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));
const StyledBox = styled('div')(({ theme }) => ({
  alignSelf: 'center',
  width: '100%',
  height: 400,
  marginTop: theme.spacing(8),
  borderRadius: theme.shape.borderRadius,
  outline: '1px solid',
  boxShadow: '0 0 12px 8px hsla(220, 25%, 80%, 0.2)',
  backgroundImage: `url(${'/static/images/templates/templates-images/hero-light.png'})`,
  outlineColor: 'hsla(220, 25%, 80%, 0.5)',
  backgroundSize: 'cover',
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(10),
    height: 700,
  },
  ...theme.applyStyles('dark', {
    boxShadow: '0 0 24px 12px hsla(210, 100%, 25%, 0.2)',
    backgroundImage: `url(${'/static/images/templates/templates-images/hero-dark.png'})`,
    outlineColor: 'hsla(210, 100%, 80%, 0.1)',
  }),
}));
const styles = (theme: { spacing: { unit: number; }; shape: { borderRadius: any; }; breakpoints: { up: (arg0: string) => any; }; transitions: { create: (arg0: string) => any; }; }) => ({
  root: {
  },
  textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      width: 200,
  },
  search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover': {
      },
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
          marginLeft: theme.spacing.unit,
          width: 'auto',
      },
  },
  searchIcon: {
      width: theme.spacing.unit * 9,
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
  },
  inputRoot: {
      color: 'inherit',
      width: '100%',
  },
  inputInput: {
      paddingTop: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      paddingLeft: theme.spacing.unit * 10,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
          width: 120,
          '&:focus': {
              width: 200,
          },
      },
  },
});

export default function SearchResult() {
  const intl = useIntl();
  let locale;
  if(intl.locale == "ja"){
    locale = MRT_Localization_JA
  }else{
    locale = MRT_Localization_EN
  }
  const location = useLocation();
  const [category, setCategory] = React.useState(location.state!==null&&location.state.hasOwnProperty("category") ? location.state["category"] : "0");
  const [keyword, setKeyword] = React.useState(location.state!==null&&location.state.hasOwnProperty("keyword") ? location.state["keyword"] : "");
  //const [refreshKey, setRefreshKey] = React.useState(0);
  //const [isActive, setIsActive] = useState(false);
  //const [category] = React.useState(location.state["category"]);
  //const [keyword] = React.useState(location.state["keyword"]);
  const [posts,setPosts] = React.useState<Post[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [open5, setOpen5] = React.useState(true);
  const {login,setLogain} = useContext(LoginContext);
  const {loading,setLoading} = useContext(LoadingContext);
  const [reload,setReload] = React.useState(0);

  // const value = {
  //   refreshKey,
  //   setRefreshKey,
  // };

  const handleChange = (event:SelectChangeEvent) => {
    setCategory(event.target.value);
    
  }
  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(event.target.value);
  }
  const reloadChange = () => {
    const i = reload+1;
    setReload(i);
    
  }

  const params = { // 渡したいパラメータをJSON形式で書く
      category: category,
      keyword: keyword
    };
  var getParams = new URLSearchParams(params);

   // TextfieldとButtonIconを合体させたコンポーネントの作成
 const AddButton = () => {
  const addButtonClick = () => {
    if(keyword !==""){
    // document.getElementById("demo-form").submit();
        ReactGA.event({
      category: "Search Button",
      action: "Search Button",
      label: keyword, // Optional
    });
    //const aaa = document.getElementById("sc");
    //aaa?.click();
    reloadChange();
     //setRefreshKey(old => old + 1)
  }};
    return (
    <IconButton onClick={() => addButtonClick()}>
      <SearchIcon />
    </IconButton>
  );
};
  //const {refreshKey, setRefreshKey} = useContext(RefreshContext);
    const resData = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_GET_DATA_API_URL;
    try{
    const bodyData = {
      category: category,
      keyword: keyword
    };
  var getParams = new URLSearchParams(params);
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  var params_str = params.toString();
  setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        setLoading(false);
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      setLoading(false);
      return jsondata;
    })
    .catch(error => {
      setLoading(false);
    });;
    setLoading(false);
    }catch{
      setLoading(false);
    }
};

  useEffect(() => {
    (async function () {

      const data = await resData();

      setPosts(data);
      setLoading(false);
    })();
   }, [reload]);

  const columns = useMemo<MRT_ColumnDef<C2List>[]>(
    //column definitions...
    () => [
      {
        accessorKey: 'ip',
        header: '',
        Cell: ({ cell ,row}) => (
          <div style={{ width: '100%' }}>
          <Box
          sx={{
            gridTemplateColumns: '1fr',
            alignItems: 'start',
            gap: '1rem',
            minWidth:1100,
            maxWidth:1100,
          }}
        >
            
          
            {(() => {
                if(row.original.category == 1){
                    return <Chip centered label="C2/C&C Server" size="small" color='default' style={{backgroundColor:'purple',color:'white',width:'140px'}} skipFocusWhenDisabled />;
                }else if(row.original.category === 2){
                    return <Chip centered label="Malware Download" size="small" color='default' style={{backgroundColor:'red',color:'white',width:'140px'}} skipFocusWhenDisabled />;
                }else if(row.original.category === 3){
                  return <Chip centered label="Phishing" size="small" color='default' style={{backgroundColor:'yellow',color:'Black',width:'140px'}} skipFocusWhenDisabled />;
              }else {
                  return <Chip centered label="Malware Hash" size="small" color='default' style={{backgroundColor:'red',color:'white',width:'140px'}} skipFocusWhenDisabled />;
            }
            })()}
          
          {/* <img
          src={logo} className="App-logo" alt="logo"
                  alt="avatar"
                  height={30}
                  loading="lazy"
                  style={{ borderRadius: '50%' }}
                /> */}
          &ensp;
          {(() => {
                if(row.original.hasOwnProperty("ip")){
                    return <Link id={cell.id} to="/searchDetail"  state={{keyword:keyword,category:category,cell:cell.getValue<string>(),table:row.original,pp:0}} onClick=
         {e => {
                // e.keyCodeは常に0になる
                    ReactGA.event({
                      category: "Click Detail",
                      action: "Click Detail",
                      label: cell.getValue(), // Optional
                    });

              }} >{cell.getValue<string>()}  </Link>;
                }else if(row.original.hasOwnProperty("domain")){
                    return <Link id={cell.id} to="/searchDetail"  state={{keyword:keyword,category:category,cell:row.original.domain,table:row.original,pp:0}} onClick=
         {e => {
                // e.keyCodeは常に0になる
                    ReactGA.event({
                      category: "Click Detail",
                      action: "Click Detail",
                      label: row.original.domain, // Optional
                    });

              }} >{row.original.domain}  </Link>;
                }else if(row.original.hasOwnProperty("url")){
                  return <Link id={cell.id} to="/searchDetail"  state={{keyword:keyword,category:category,cell:row.original.url,table:row.original,pp:0}} onClick=
         {e => {
                // e.keyCodeは常に0になる
                    ReactGA.event({
                      category: "Click Detail",
                      action: "Click Detail",
                      label: row.original.url, // Optional
                    });

              }} >{row.original.url}  </Link>;
              }else {
                  return <Link id={cell.id} to="/searchDetail"  state={{keyword:keyword,category:category,cell:row.original.hash,table:row.original,pp:0}} onClick=
         {e => {
                // e.keyCodeは常に0になる
                    ReactGA.event({
                      category: "Click Detail",
                      action: "Click Detail",
                      label: row.original.hash, // Optional
                    });

              }} >{row.original.hash}  </Link>;
            }
            })()}
          
          
          </Box>
          </div>
        ),
      },
    ],
    [posts],
    //end
  );
  const data = posts
  const table = useMaterialReactTable({
    columns,
    data,
    defaultColumn: {
     // minSize: 1100,
    // width:"100%"
    },
    enableTopToolbar: false,
    enableClickToCopy: false,
    enableColumnActions: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableEditing: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    enableSorting: false,
    autosizeColumns:"none",
    localization: locale,
    initialState: {
      density: 'compact',
      pagination: { pageIndex: 0, pageSize: 10 },
    },
    muiDetailPanelProps: () => ({
    }),
    //custom expand button rotation
    muiExpandButtonProps: ({ row, table }) => ({
      onClick: () => table.setExpanded({ [row.id]: !row.getIsExpanded() }), //only 1 detail panel open at a time
      sx: {

      },
    }),
    //conditionally render detail panel
    renderDetailPanel: ({ row }) =>
      row.original.ip ? (
        <Container maxWidth="xl">
        <div style={{ width: '100%' }}>
        <Box maxWidth="xl"
          sx={{
            display: 'grid',
            alignItems: 'start',
            width: 1,
            autosizeColumns:"none",
          }}
        >
        
          {(() => {
            var text = "";
            var num = 0;
            if(row.original.dtl.hasOwnProperty("port")){
                text=text.concat(intl.formatMessage({ id: "langID00019" })+":").concat(row.original.dtl.port);
                num++;
            } 
            if(row.original.dtl.hasOwnProperty("ana_country")){
                if(num!=0){
                  text=text.concat(",")
                }
                text=text.concat(intl.formatMessage({ id: "langID00023" })+":").concat(row.original.dtl.ana_country);
                num++;
            }
            if(row.original.dtl.hasOwnProperty("uh_file_type")){
                if(num!=0){
                  text=text.concat(",")
                }
                text=text.concat(intl.formatMessage({ id: "langID00041" })+":").concat(row.original.dtl.uh_file_type);
            }
            return <div style={{ width: '100%' }}>
            &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
            {text}
            </div>;
          })()}
        </Box>
        </div>
        </Container>

      ) : null,
  });


  return (
    <Box
      id="hero"
      sx={(theme) => ({
        //width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
        }),
      })}
    >
      <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 0, sm: 13 },
          pb: { xs: 0, sm: 0 },
        }}
      >
            <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 2 ,fontsize: "10px",height:60}}> 
        <FormControl sx={{ m: 1, minWidth: 100,marginRight:2,margin:"0 0 0 0", md: 'flex',height:60}}>
        <InputLabel id="demo-simple-select-autowidth-label" sx={{ marginTop:-1, md: 'flex'}}></InputLabel>
        <Select
          labelId="demo-simple-select-autowidth-label"
          id="demo-simple-select-autowidth"
          //value={location.state["category"]}
          defaultValue={category}
          onChange={handleChange}
          sx={{ maxWidth:"120px"}}
        >
          <MenuItem value={0}><FormattedMessage id = "langID00005"/></MenuItem>
          <MenuItem value={1}><FormattedMessage id = "langID00006"/></MenuItem>
          <MenuItem value={2}><FormattedMessage id = "langID00007"/></MenuItem>
          <MenuItem value={3}><FormattedMessage id = "langID00008"/></MenuItem>
          <MenuItem value={4}><FormattedMessage id = "langID00009"/></MenuItem>
        </Select>
      </FormControl >
            <InputLabel htmlFor="email-hero" sx={visuallyHidden} >
            </InputLabel>
            <TextField
              id="email-hero"
              hiddenLabel
              size="medium"
              variant="outlined"
              placeholder={intl.formatMessage({ id: "langID00016" })}
              //value={location.state["keyword"]}
              defaultValue={keyword}
              autoComplete= 'off'
              InputProps={{ endAdornment: <AddButton /> }}
              onChange={handleChangeInput}
              sx={{ m: 1, minWidth: 700,height:60}}
              onKeyDown={e => {
                  if(keyword !==""){
                // e.keyCodeは常に0になる
                if (e.key === 'Enter') {
                  // エンターキー押下時の処理
                  // document.getElementById("demo-form").submit();
                      ReactGA.event({
                      category: "Search Button",
                      action: "Search Button",
                      label: keyword, // Optional
                });
                  reloadChange();
                  //const aaa = document.getElementById("sc");
                  //aaa?.click();
                   //setRefreshKey(old => old + 1);
                }
                  }
              }}
            />
            <Typography
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 0.5,
              textAlign: 'center',
              color: 'text.secondary',
              width: { sm: '100%', md: '80%' },
            }}
          >

          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            useFlexGap
            sx={{ pt: 2, width: { xs: '100%', sm: 'auto' } }}
          ></Stack>
            </Box>
            <Link hidden id="sc" to={"/search?"+getParams} state={{keyword:keyword,category:category}}>テキスト</Link>
      </Container>
    <input type="hidden" name="recaptcha_response" id="recaptchaResponse"></input>
    <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 14, sm: 0 },
          pb: { xs: 16, sm: 0 },
        }}
      >
      <br/>
        <b><FormattedMessage id = "langID00017"/></b>
    <MaterialReactTable localization={MRT_Localization_JA} table={table}  />
    </Container>
    </Box>
  );
}